import React from "react";
import {
  AxiosGetSecretApi,
  AxiosPatchSecretApi,
} from "../../../utils/fetchApi";
import MainLayout from "../../../components/Layout/MainLayout";
import {
  Form,
  Input,
  Select,
  Button,
  Popconfirm,
  message,
  DatePicker,
  TimePicker,
} from "antd";
import Card from "../../../components/Card";
import moment from "moment";
moment.locale("vi");
class ChinhSuaNhatKy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listUser: [],
      listDepartment: [],
      isLoading: false,
      count: 0,
    };
    this.form = React.createRef();
  }

  componentDidMount() {
    this.getAllSelectData();
    this.getDataNhatKy();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.count !== this.state.count && this.state.count === 2) {
      let listUser = this.listUser.filter(
        (e) => e.MaPhongBan === this.state.MaPhongBan
      );
      this.setState({
        listUser: listUser,
      });
    }
  }

  async getAllSelectData() {
    let [listDepartment, listUser] = await Promise.all([
      AxiosGetSecretApi(`/api/user/phongban`),
      AxiosGetSecretApi(`/api/nhat-ky/all-username`),
    ]);

    listDepartment = listDepartment.map((e) => {
      return {
        name: e.MoTa,
        value: e.MaPhongBan,
        TenPhongBan: e.TenPhongBan,
      };
    });

    this.setState({
      listDepartment,
      listUser: listUser && Array.isArray(listUser) ? listUser : [],
    });

    this.listUser = listUser && Array.isArray(listUser) ? listUser : [];

    this.setState({
      count: this.state.count++,
    });
  }

  async getDataNhatKy() {
    let id = this.props.match.params.id;
    let responseData = await AxiosGetSecretApi(`/api/nhat-ky/getById?ID=${id}`);
    if (
      responseData &&
      Array.isArray(responseData) &&
      responseData.length !== 0
    ) {
      let e = responseData[0];
      this.form.current.setFieldsValue({
        user: e.user,
        PhongBan: e.MaPhongBan,
        object: e.noiDung,
        date: moment(new Date(e.ngay)).utc(0),
        time: moment(new Date(e.ngay)).utc(0),
      });
      this.setState({
        count: this.state.count++,
        MaPhongBan: e.MaPhongBan,
      });
    }
  }

  handleSubmit() {
    this.setState({ isLoading: true });
    this.form.current
      .validateFields()
      .then((e) => {
        let date = `${e.date.format("YYYY-MM-DD")}T${e.time.format("LTS")}`;
        let data = {
          OBJECTID: this.props.match.params.id,
          user: e.user,
          phongBan: this.state.listDepartment.filter(
            (o) => o.value === e.PhongBan
          )[0].TenPhongBan,
          ngay: new Date(date),
        };
        this.updateNhatKy(data);
        this.setState({ isLoading: false });
      })
      .catch(this.setState({ isLoading: false }));
  }

  async updateNhatKy(data) {
    let response = await AxiosPatchSecretApi("/api/nhat-ky/update", data);
    if (response.length > 0) {
      message.success("Cập nhật nhật ký hoạt động thành công");
      setTimeout(() => {
        this.props.history.push("/nhat-ky");
      }, 1000);
    } else {
      message.error("Cập nhật nhật ký hoạt động không thành công");
    }
  }

  range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  disabledHours = () => {
    if (this.form.current && this.form.current.getFieldValue("date")) {
      let selectedDate = new Date(
        this.form.current.getFieldValue("date")._d
      ).getDate();
      let nowDate = new Date().getDate();
      if (selectedDate === nowDate) {
        let hour = new Date().getHours();
        return this.range(0, 24).splice(hour + 1, 24);
      }
    }
    return [];
  };

  disabledMinutes = () => {
    if (this.form.current && this.form.current.getFieldValue("date")) {
      let selectedDate = new Date(
        this.form.current.getFieldValue("date")._d
      ).getDate();
      let nowDate = new Date().getDate();
      if (selectedDate === nowDate) {
        let minute = new Date().getMinutes();
        return this.range(0, 60).splice(minute + 1, 60);
      }
    }
    return [];
  };

  onChangeUser(value, option) {
    this.state.listDepartment.forEach((e) => {
      if (e.value === option.id) {
        this.form.current.setFieldsValue({
          PhongBan: e.value,
        });
      }
    });
  }

  onChangeDepartment(value, option) {
    let listUser = this.listUser.filter((e) => e.MaPhongBan === option.id);
    this.setState({
      listUser: listUser,
    });
    this.form.current.setFieldsValue({
      user: undefined,
    });
  }

  render() {
    return (
      <MainLayout {...this.props} title={"Nhật ký hoạt động"}>
        <div className="page-with-card">
          <Card title="Nhật ký hoạt động">
            <div className="create-user">
              <div className="content">
                <Form
                  onSubmit={this.handleSubmit}
                  style={{ width: "600px" }}
                  layout="vertical"
                  ref={this.form}
                >
                  <div className="sub-title">Chỉnh sửa nhật ký hoạt động</div>

                  <Form.Item
                    label="Người dùng"
                    style={{ marginBottom: "20px" }}
                    name="user"
                    hasFeedback
                    rules={[
                      { required: true, message: "Vui lòng chọn người dùng!" },
                    ]}
                  >
                    <Select
                      className="select"
                      showSearch
                      onChange={(value, option) => {
                        this.onChangeUser(value, option);
                      }}
                    >
                      {this.state.listUser.map((e, i) => (
                        <Select.Option key={i} value={e.user} id={e.MaPhongBan}>
                          {e.user}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Phòng ban"
                    style={{ marginBottom: "20px" }}
                    name="PhongBan"
                    hasFeedback
                    rules={[
                      { required: true, message: "Vui lòng phòng ban !" },
                    ]}
                  >
                    <Select
                      className="select"
                      showSearch
                      optionFilterProp="name"
                      onChange={(value, option) => {
                        this.onChangeDepartment(value, option);
                      }}
                    >
                      {this.state.listDepartment.map((e, i) => (
                        <Select.Option
                          value={e.value}
                          key={i}
                          name={e.name}
                          id={e.value}
                        >
                          {e.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label={
                      <div
                        style={{
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontSeight: "400",
                          lineHeight: "19px",
                          letterSpacing: "0em",
                          textAlign: "left",
                          paddingBottom: "3px",
                        }}
                      >
                        Đối tượng
                      </div>
                    }
                    style={{ marginBottom: "20px" }}
                    name="object"
                  >
                    <Input className="input" disabled></Input>
                  </Form.Item>

                  <Form.Item
                    label="Ngày"
                    style={{ marginBottom: "20px" }}
                    name="date"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn ngày !",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="Vui lòng chọn ngày"
                      allowClear={false}
                      showToday={false}
                      disabledDate={(current) => {
                        return current && current > moment().endOf("day");
                      }}
                      onChange={() => {
                        this.form.current.setFieldsValue({
                          time: undefined,
                        });
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Giờ"
                    style={{ marginBottom: "20px" }}
                    name="time"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn giờ !",
                      },
                    ]}
                  >
                    <TimePicker
                      type="time"
                      placeholder="Vui lòng chọn giờ"
                      allowClear={false}
                      showNow={false}
                      disabledHours={this.disabledHours}
                      disabledMinutes={this.disabledMinutes}
                    />
                  </Form.Item>

                  <Popconfirm
                    title={"Bạn có chắc muốn cập nhật?"}
                    okText="Có"
                    cancelText="Không"
                    onConfirm={(e) => this.handleSubmit(e)}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        className="button-create-user"
                        type="primary"
                        htmlType="submit"
                        loading={this.state.isLoading}
                      >
                        Cập nhật
                      </Button>
                    </div>
                  </Popconfirm>
                </Form>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}

export default ChinhSuaNhatKy;
